import React from 'react';
import { Box } from '@mui/material';
import RegisterForm from '../components/auth/RegisterForm';

const RegisterPage: React.FC = () => {
    return (
        <Box>
            <RegisterForm />
        </Box>
    );
};

export default RegisterPage;
